// 接诊台相关路径
export const receptionPath = {
    login: "/pc/login",
    home: '/pc'
}

export const workBench = {
    home: '/workbench/web/main',
}